import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "input-group-append" }
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = ["disabled"]

import { computed, ref, toRef } from 'vue'
    import { MonthPicker, MonthPickerInput } from 'vue-month-picker'

    import type { ProjectScheduledLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectScheduledLifecycleSetter"
    import type { MonthPickerDate } from "@common/Components/MonthPickerDialog"
    import { MonthYearHelpers } from "@common/types"

    // props
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectScheduledLifecycleSetter',
  props: {
    viewModel: {}
  },
  emits: ["confirm"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    // emits
    const emit = __emit

    // vm shortcut
    const vm = toRef(props, 'viewModel')

    // state
    const opened = computed(() => vm.value?.opened ?? false)

    const startDate = computed<MonthPickerDate | null>({
        get: () => vm.value.startDate,
        set: v => vm.value.startDate = v
    })

    const isStartDateSet = computed(() =>
        !!(startDate.value && startDate.value.monthIndex && startDate.value.year)
    )

    const isStartDateValid = computed(() =>
        (window as any).MonthPickerDate?.isValid
            ? (window as any).MonthPickerDate.isValid(startDate.value, vm.value.minStartDate, vm.value.maxStartDate)
            : true
    )

    // local UI state
    const isStartDateMonthPickerVisible = ref(false)

    // label formatting
    const startDateLabel = computed<string | null>(() =>
    {
        if (!isStartDateSet.value) return null

        const date = new Date(
            startDate.value!.year,
            startDate.value!.monthIndex - 1,
            1
        )

        return new Intl.DateTimeFormat('en-US', {
            month: 'long',
            year: 'numeric'
        }).format(date)
    })

    // actions
    function onStartDateChange(date: MonthPickerDate)
    {
        startDate.value = date
    }

    function confirm()
    {
        if (isStartDateSet.value && isStartDateValid.value)
        {
            const date = MonthYearHelpers.build(
                vm.value.startDate.year,
                vm.value.startDate.monthIndex
            )

            emit('confirm', vm.value.projectId, date)
        }
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Change Project Lifecycle to Scheduled", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[5] || (_cache[5] = _createElementVNode("p", null, [
                  _createTextVNode(" You are about to change the project lifecycle to the "),
                  _createElementVNode("strong", null, "Scheduled"),
                  _createTextVNode(" stage. Please ensure the start date is set and valid. ")
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", null, "Start date:", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("input", {
                      value: startDateLabel.value,
                      placeholder: "Select a start date",
                      type: "text",
                      class: "form-control pointer bg-white",
                      readonly: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (isStartDateMonthPickerVisible.value = !isStartDateMonthPickerVisible.value))
                    }, null, 8 /* PROPS */, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-secondary",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (isStartDateMonthPickerVisible.value = !isStartDateMonthPickerVisible.value))
                      }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("i", {
                          class: "fa-regular fa-calendar",
                          "aria-hidden": "true"
                        }, null, -1 /* CACHED */)
                      ]))])
                    ])
                  ]),
                  (!isStartDateSet.value || !isStartDateValid.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, " A start date is required and cannot be in the past. "))
                    : _createCommentVNode("v-if", true),
                  _withDirectives(_createVNode(_unref(MonthPicker), {
                    onChange: onStartDateChange,
                    "min-date": vm.value.minStartDate,
                    "max-date": vm.value.maxStartDate,
                    "default-month": vm.value.defaultMonth,
                    "default-year": vm.value.defaultYear
                  }, null, 8 /* PROPS */, ["min-date", "max-date", "default-month", "default-year"]), [
                    [_vShow, isStartDateMonthPickerVisible.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "button",
                  onClick: confirm,
                  class: "btn btn-primary",
                  disabled: !isStartDateSet.value || !isStartDateValid.value
                }, "Confirm", 8 /* PROPS */, _hoisted_12)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})